import { AspectRatio, Box, Image } from '@mantine/core';
import { isMobile } from 'is-mobile';
import {
  PRODUCT_CARD_PREVIEW_BG,
  PRODUCT_CARD_PREVIEW_IMAGE_HEIGHT,
} from '@/constants/productPreview';

type ProductPreviewFrameProps = {
  src: string;
  alt: string;
};

/** Same 1:1 frame as `ProductCard` / dashboard product tiles (`fit: contain`). */
export function ProductPreviewFrame({ src, alt }: ProductPreviewFrameProps) {
  const previewHeight = isMobile()
    ? PRODUCT_CARD_PREVIEW_IMAGE_HEIGHT.mobile
    : PRODUCT_CARD_PREVIEW_IMAGE_HEIGHT.desktop;

  return (
    <AspectRatio ratio={1} style={{ height: previewHeight, width: previewHeight }}>
      <Box
        style={{
          width: '100%',
          height: '100%',
          overflow: 'hidden',
          backgroundColor: PRODUCT_CARD_PREVIEW_BG,
          borderRadius: 'var(--mantine-radius-md)',
          border: '1px solid var(--mantine-color-gray-3)',
        }}
      >
        <Image
          src={src}
          alt={alt}
          fit="contain"
          style={{
            width: '100%',
            height: '100%',
            objectPosition: 'center',
          }}
        />
      </Box>
    </AspectRatio>
  );
}
